import { Button, CInputControl } from "core/components/form-controls";
import AppLayout from "core/layouts/AppLayout";
import PageHeader from "core/components/Header/PageHeader";
import { useCustomNavigate } from "core/hooks/useCustomNavigate";
import { RouterName, route } from "core/router";
import { getFieldInputProps } from "core/utils/form";
import { useFormikCustom } from "core/hooks/useFormikCustom";
import CCountDown from "core/components/CCountDown";
import { useEffect, useRef, useState } from "react";
import { _t } from "core/language";
import { API_SEND_PASSWORD, API_VERIFY_TEMPORARY_PASSWORD } from "../api";
import API from "core/networks/API";
import { useDataFormSave, useUpdateFormSave } from "../hooks";
// import { validationSchemaRequestPassword } from "./Auth.config";
import { REGEX } from "core/config/constant";

const ForgotPwRequestOtp = () => {
  const navigate = useCustomNavigate();
  const dataFormSave = useDataFormSave()
  const [dataSaveForm, setDataSaveForm] = useState(dataFormSave)

  const formik = useFormikCustom({
    initialValues: {
      password: "",
      email: dataFormSave?.email,
      validSubmit: false,
    },
    // validationSchema:validationSchemaRequestPassword,
    validateOnMount: false, // Prevent validation on page load (default behavior)
    validateOnChange: false, // Validate on field changes
    validateOnBlur: false,   // Validate when a field is blurred
    onSubmit(values, formikHelpers) {
      console.log(values, formikHelpers)
      handleVerifyTemporaryPassword()

      setTimeout(() => {
        formikHelpers.setSubmitting(false)
      }, 2000)
    },
  });

  const formikRef = useRef(formik);
  useEffect(() => {
    formikRef.current = formik;
  }, [formik]);

  useEffect(() => {
    const isValidSubmit = !!(formikRef.current.values.password);
    // const isValidSubmitError = (formikRef.current.errors.password);
    // if (isValidSubmitError) {
    //   formikRef.current.setFieldValue('validSubmit', false);
    //   return
    // }
    if (formikRef.current.values.validSubmit !== isValidSubmit) {
      formikRef.current.setFieldValue('validSubmit', isValidSubmit);
    }
  }, [formik.values.password, formik.errors.password]);

  useUpdateFormSave(dataSaveForm)

  const [countTime, setCountTime] = useState(1)
  const [stateCountDown, setStateCountDown] = useState(true)

  const handleSendPasswordToMail = async () => {

    const dataRequest = {
      email: formik.values.email,
    }
    try {
      const { data: response } = await API.post(`${API_SEND_PASSWORD}`, dataRequest)
      if (response && response?.code === 200) { /* empty */ }
    } catch (e: any) { 
      console.log(e, 'errors');
    }
  }

  const handleVerifyTemporaryPassword = async () => {

    const dataRequest = {
      email: formik.values.email,
      temporary_password: formik.values.password,
    }
    try {
      const { data: response } = await API.post(`${API_VERIFY_TEMPORARY_PASSWORD}`, dataRequest)
      if (response && response?.code === 200) {
        const dataSave = { ...dataFormSave, temporary_password: formik.values.password }
        setDataSaveForm(dataSave)
        setTimeout(() => {
          navigate(route(RouterName.FORGOT_PW_FORM))
        }, 200)

      }
    } catch (e: any) {
      if (e?.response?.data?.code === 400) {
        formik.setErrors({ password: e?.response?.data?.msg })
      }
      if (e?.response?.data?.code === 422) {
        const msgError = e?.response?.data?.errors[0]?.error || 'ERROR SERVER'
        formik.setErrors({ password: msgError })
      }
    }
  }

  useEffect(() => {
    handleSendPasswordToMail();
  }, [])

  const handleGoBack = () => {
    navigate(-1)
  }

  const handleSubmit = (e: any) => {
    const { onSubmit, errors } = formik;
    console.log(errors, 'errors')
    onSubmit(e)
  };

  const handleTimeEnd = (e: any) => {
    console.log(e, 'handleTimeCountDownEnd')
    setStateCountDown(false)
    // formik.onSubmit(e)
  }
  const handleResendOtp = (e: any) => {
    console.log(e, 'handleTimeCountDownEnd')
    setCountTime(countTime + 1)
    setStateCountDown(true)
    handleSendPasswordToMail()
  }

  const renderLabelCountDown = () => {
    const lang = (window as any)._APP_LANG
    let labelCountDown = null
    const countDownComponent = <CCountDown
      handleTimeEnd={handleTimeEnd}
      timeSetDefault='05:00'
      count={countTime}
      countdown={300}
    />
    switch (lang) {
      case 'ko':
        labelCountDown = (<p className=" text-[11px] tracking-tight text-zinc-800 font-normal">
          {_t('auth.LabelDidntReceiveYourPassword')} {countDownComponent}
          {" "}{_t('auth.LabelYouCanResendItAfter')}
        </p>)
        break;
      default:
        labelCountDown = (<p className=" text-[11px] tracking-tight text-zinc-800 font-normal">
          {_t('auth.LabelDidntReceiveYourPassword')} {" "}
          {_t('auth.LabelYouCanResendItAfter')} {" "}
          {countDownComponent}
        </p>)
        break
    }
    if (stateCountDown) {
      return labelCountDown
    }
    return ''
  }

  return (
    <AppLayout className={"login-client-page"}>
      <PageHeader sticky showCart={false} title={_t('auth.LabelForgotPw')} handleGoBack={handleGoBack} />
      <div className="mt-1">
        <form onSubmit={handleSubmit} className="flex flex-col px-4 py-12 w-full tracking-tighter bg-white">
          <h1 className="text-lg font-bold tracking-tighter text-neutral-900">
            {_t('auth.LabelCheckYourEmailForTemporaryPassword')}
          </h1>

          <CInputControl
            className=" font-medium mt-10 mb-1 min-h-[auto]"
            label={_t('auth.LabelTemporaryPassword')}
            error=""
            type="password"
            format={REGEX.TEMPORARY_PASSWORD}
            placeholder={_t('auth.PlaceHolderTemporaryPassword')}
            {...getFieldInputProps(formik, 'password')}
          />
          {renderLabelCountDown()}
          {!stateCountDown && <p className=" text-[11px] tracking-tight text-zinc-800 font-normal">{_t('auth.LabelDidntReceiveYourPassword')}{_t('auth.LabelYouCanResendAgain')}</p>}
          <div className="absolute left-0 bottom-0 w-full px-4 flex gap-2 mb-[50px]">
            <Button size="lg" 
              label={_t('auth.Resend')} disabled={stateCountDown} 
              onClickBtn={handleResendOtp} classBtn="w-full mb-2 hover:bg-white focus:bg-white" 
            />
            <Button size="lg" 
              disabled={!formik.values?.validSubmit}
              label={_t('auth.Confirm')} 
              type="submit" 
              classBtn="w-full mb-2 hover:bg-white focus:bg-white" 
            />
          </div>
        </form>
      </div >

    </AppLayout >
  );
};

export default ForgotPwRequestOtp;
